import React, { useState } from "react";
import { BiSolidPhoneCall } from "react-icons/bi";
import { MdEmail } from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { IoClose } from "react-icons/io5";
import SupportPopup from "../SupportPopup/SupportPopup";

function ButtonList(props) {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show02, setShow02] = useState(false);
    const handleClose02 = () => setShow02(false);
    const handleShow02 = () => setShow02(true);



    return (
        <>

            <Modal
                show={show02}
                onHide={handleClose02}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose02} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../../assets/images/forewardFormSubmit.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your message is sent!
                    </h3>
                    <p className="text-center mb-0">
                        Our staff will be in contact shortly to answer any questions and get you sorted.
                    </p>
                </Modal.Body>
            </Modal>

            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className="center-form-modal"
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <h3 className="text mb-5">How can we help?</h3>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <SupportPopup subject={props.subject} onHideForm={(formHide) => setShow(formHide)} onShowForm={(formShow) => setShow02(formShow)} />
                </Modal.Body>
            </Modal>




            <div className="btn-group-list" role="group" aria-label="Basic example">
                <a type="button" className="btn btn-primary btn_default2" onClick={handleShow}>
                    <div className="gab_icon">
                        <img src={require('../../assets/images/001-email.png')} alt="" />
                    </div>
                    Email Us
                </a>
                <a href="tel:(805) 650-1534" className="btn btn-primary btn_default2">
                    <div className="gab_icon">
                        <img src={require('../../assets/images/005-call.png')} alt="" />
                    </div>
                    Call Us
                </a>
            </div>
        </>
    );
}

export default ButtonList;